import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Clock, User } from 'lucide-react'
import { announcements } from '../data'
import { formatDate } from '../utils'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/common'
import { DocsPage } from './DocsPage'
export function AnnouncementPage() {
  return (
    <>
      <section className="relative h-60 bg-gray-900 text-white">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/announcement-banner.jpg)` }}></div>
        <div className="container-custom h-full flex items-center relative z-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">公告中心</h1>
            <p className="text-lg text-white/80">了解最新系统动态和行业资讯</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-4xl font-bold mb-4"
            >
              最新公告
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              及时了解系统更新、政策变化和行业动态
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {announcements.map((announcement, index) => (
              <motion.div
                key={announcement.id}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <Card className="h-full hover:shadow-xl transition-shadow duration-300">
                  <CardHeader>
                    <div className="flex items-center justify-between mb-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${announcement.category === 'notice' ? 'bg-blue-100 text-blue-700' :
                        announcement.category === 'news' ? 'bg-green-100 text-green-700' :
                          'bg-orange-100 text-orange-700'
                        }`}>
                        {announcement.category === 'notice' ? '通知' :
                          announcement.category === 'news' ? '新闻' :
                            '更新'}
                      </span>
                    </div>
                    <CardTitle>{announcement.title}</CardTitle>
                    <CardDescription>{announcement.summary}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <div className="flex items-center space-x-1">
                        <Clock className="w-4 h-4" />
                        <span>{formatDate(announcement.date)}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <User className="w-4 h-4" />
                        <span>{announcement.author}</span>
                      </div>
                    </div>
                    <Link
                      to={`/announcement/${announcement.id}`}
                      className="inline-block mt-4 text-primary-500 font-medium hover:underline"
                    >
                      查看详情 →
                    </Link>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
          <DocsPage asComponent={true} />
        </div>
      </section>
    </>
  )
}
